if (!customElements.get("dl-js-float")) {
  class DL_Float extends HTMLElement {
    constructor() {
      super();
      const object = this;
      // console.log(this);
      object.area = object.closest(".dl-js-float__wrap");
      object.init();
      object.onScrollHandler = object.onScroll.bind(object);
      window.addEventListener("scroll", object.onScrollHandler, false);
      window.addEventListener("resize", object.onResize.bind(object));
    }

    init() {
      // console.log(this.getBoundingClientRect())
      if (DL_media() == "PC") {
        this.observer = new ResizeObserver((entries)=>{
          entries.forEach((entry)=>{
            this.onScroll();
          });
        });
        this.observer.observe(this);
        // console.log(this.overFlg)
        this.onScroll();
      } else {
        this.style.position = "relative";;
        this.style.width = "100%";;
        this.style.top = "auto";;
        this.style.left = "auto";;
        this.style.bottom = "auto";;
      }
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (DL_media() == "PC") {
        this.areaHeight = this.area.offsetHeight;
        this.areaWidth = this.area.offsetWidth;
        this.areaTop = DL_offsetTop(this.area);
        this.areaLeft = DL_offsetLeft(this.area);
        this.areaBottom = this.areaHeight + this.areaTop;
        //エラーが出るためヘッダの高さを70で決め打ち
        //this.areaAdjust = document.querySelector(".dl-header").offsetHeight + 60 ;
        this.areaAdjust = 130;
        this.h = this.offsetHeight;
        this.overFlg = false;
        if (window.innerHeight < this.h + this.areaAdjust) {
          this.overFlg = true;
        }
        // var scrollBottom = scrollTop + window.innerHeight;
        //エラーが出るためヘッダの高さを70で決め打ち
        //var headerHeight = document.querySelector(".dl-header").offsetHeight;
        var headerHeight = 70;
        var scroll = scrollTop + this.areaAdjust;
        var position, top, left, bottom, width;
        if (this.overFlg) {
          // 高さが画面内より大きい時
          if ((scrollTop + window.innerHeight) >= (this.areaTop + this.h)) {

            if ((scrollTop + window.innerHeight) >= this.areaBottom) {
              position = "absolute";
              width = "100%";
              top = "auto";
              left = "0";
              bottom = "0";
            } else {
              position = "fixed";
              width = this.areaWidth + "px";
              top = "auto";
              // top = window.innerHeight - (this.h + this.areaAdjust) + "px";;
              left = this.areaLeft + "px";
              bottom = 0;
            }
          } else {
            position = "relative";
            width = "100%";
            top = "auto";
            left = "auto";
            bottom = "auto";
          }

        } else {
          // 高さが画面内に収まっている時
          if (scroll >= this.areaTop) {
            //エリアに到達
            if ((scroll + this.h) >= this.areaBottom) {
              //エリアを抜ける
              position = "absolute";
              width = "100%";
              top = "auto";
              left = "0";
              bottom = "0";
            } else {
              //エリア内
              position = "fixed";
              width = this.areaWidth + "px";
              top = this.areaAdjust + "px";
              left = this.areaLeft + "px";
              bottom = "auto";
            }
          } else {
            position = "relative";
            width = "100%";
            top = "auto";
            left = "auto";
            bottom = "auto";
          }
        }
        this.style.position = position;
        this.style.width = width;
        this.style.top = top;
        this.style.left = left;
        this.style.bottom = bottom;
      }
    }
    onResize() {
      this.init();
    }
  }
  customElements.define("dl-js-float", DL_Float);
}

if (!customElements.get("dl-js-float_cartbtn")) {
  class DL_Float_CartBtn extends HTMLElement {
    constructor() {
      super();
      const object = this;
      // console.log(this);
      object.area = object.closest("#cart");
      object.init();
      object.onScrollHandler = object.onScroll.bind(object);
      window.addEventListener("scroll", object.onScrollHandler, false);
      window.addEventListener("resize", object.onResize.bind(object));
    }

    init() {
      const object = this;
      object.areaHeight = object.area.offsetHeight;
      object.areaWidth = object.area.offsetWidth;
      object.areaTop = DL_offsetTop(object.area);
      object.areaLeft = DL_offsetLeft(object.area);
      object.areaAdjust = 20;
      object.overFlg = false;
      if (window.innerHeight < object.areaTop + object.offsetHeight + object.areaAdjust * 2) {
        object.overFlg = true;
      }
      object.onScroll();
    }
    onScroll() {
      if (DL_media() == "SP") {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const object = this;
        var headerHeight = document.querySelector(".dl-header").offsetHeight;
        var footerTop = DL_offsetTop(document.querySelector(".dl-footer"));
        var adjust = scrollTop + headerHeight + object.areaAdjust;
        var position, top, left, bottom, width;
        if (scrollTop + window.innerHeight > footerTop) {
          DL_removeClass(this, "is-active");
        } else if (scrollTop > object.areaTop + object.areaHeight) {
          DL_addClass(this, "is-active");
        } else {
          DL_removeClass(this, "is-active");
        }
      }
    }
    onResize() {
      const object = this;
      object.init();
    }
  }
  customElements.define("dl-js-float_cartbtn", DL_Float_CartBtn);
}
